import {CommonErrorModal} from "@app/components/modals/CommonErrorModal"
import {CommonSelectModal} from "@app/components/modals/CommonModal"
import { paymentMethodColumns } from "@app/pages/billling/Cards/table";
import {Button} from "@shortsworks/ui"
import {StoryGroupData, AccountPaymentMethodData} from "@shortsworks/user-api"
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel, ColumnDef, CellContext, flexRender, Row,
} from "@tanstack/react-table"
import {TrashIcon} from "lucide-react"

interface PaymentMethodTableProps {
  data: AccountPaymentMethodData[];
}

interface Card {
  cardNumber: string;
  expiryDate: string;
  isPrimary: boolean;
  isDeleted: boolean;
}

const columns: ColumnDef<AccountPaymentMethodData>[] = [
  {
    header: '카드 번호',
    accessorKey: 'cardNumber',
    cell: ({ getValue }: { getValue: any }) => getValue()
  },
  {
    header: '카드 만료일',
    accessorKey: 'cardExpirationMonth', // 월
    // getValue로 가져오는 값이
    cell: ({ getValue, row }: { getValue: any, row:  Row<AccountPaymentMethodData>}) => {
      const year = row.original.cardExpirationYear;
      return `${getValue()}/${year}`;
    },
  },
  {
    header: '기본 카드 설정',
    accessorKey: 'setDefaultPaymentMethod',
    // cell: ({ getValue, row }: { getValue: any, row:  Row<AccountPaymentMethodData>}) => {
    //   const paymentMethod = row.original;
    //
    //   const setDefaultCard = async (cardId: string) => {
    //     if (!isSuccessGetUserInfo) {
    //       return showModal(CommonErrorModal, {
    //         title: "회원 정보를 가져오는 데 실패했습니다.",
    //       });
    //     }
    //     const modalResult = await showModal(CommonSelectModal, {
    //       title: "기본 카드로 설정하시겠습니까?",
    //     }).promise();
    //     if (modalResult.value) {
    //       const result = await mutateAsyncUpdateDefaultMethod({
    //         data: {
    //           id: cardId,
    //           account_id: userInfoData.data.accountId,
    //         },
    //       });
    //       if (!result.data.success) {
    //         return showModal(CommonErrorModal, {
    //           title: "기본 카드 변경에 실패했습니다.",
    //         });
    //       }
    //     }
    //   };
    //
    //   return (
    //       paymentMethod.isDefault ? (
    //             <Button className="w-fit font-bold" disabled={true} variant="outline">
    //               기본 결제 카드
    //             </Button>
    //         ) : (
    //             <Button className="w-fit" variant="outline" onClick={() => setDefaultCard(paymentMethod.id)}>
    //               결제 카드 설정
    //             </Button>
    //         )
    //   );
    // },
  },
  {
    header: '카드 삭제',
    accessorKey: 'deletePaymentMethod',
    cell: ({row}: {row: Row<AccountPaymentMethodData>}) => {
      const paymentMethod = row.original;
      return (
          <Button
              className="w-32"
              variant="secondary"
              disabled={paymentMethod.isDefault}
              // onClick={() => handleRemovePaymentMethod(paymentMethod.id)}
          >
            <TrashIcon/>
          </Button>
      );
    },
  },
];

export const PaymentMethodTable = ({ data }: PaymentMethodTableProps) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });


  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
      {table.getHeaderGroups().map(headerGroup => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map(header => (
                <th className="text-left" key={header.id}>
                  {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                      )}
                </th>
            ))}
          </tr>
      ))}
      </thead>
        {/*<tbody>*/}
        {/*{table.getRowModel().rows.map(row => (*/}
        {/*    <tr key={row.id}>*/}
        {/*      {row.getVisibleCells().map(cell => (*/}
        {/*          <td className="text-left" key={cell.id}>*/}
        {/*            {flexRender(cell.column.columnDef.cell, cell.getContext())}*/}
        {/*          </td>*/}
        {/*      ))}*/}
        {/*    </tr>*/}
        {/*))}*/}
        {/*</tbody>*/}
    </table>
  );
};
